import { render, staticRenderFns } from "./ProHero.vue?vue&type=template&id=97d7f924&scoped=true&"
import script from "./ProHero.vue?vue&type=script&lang=js&"
export * from "./ProHero.vue?vue&type=script&lang=js&"
import style0 from "./ProHero.vue?vue&type=style&index=0&id=97d7f924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d7f924",
  null
  
)

export default component.exports